import {
  getFirestore,
  onSnapshot,
  doc,
  where,
  query,
  getDoc,
  getDocs,
  updateDoc,
  collection,
  serverTimestamp,
  setDoc,
  deleteDoc,
} from "firebase/firestore";

import { getAuth } from "firebase/auth";
import moment from "moment";
import lodash from "lodash";
import { TYPES } from "./income_detail.type";
import { REF } from "../ref";
import { app } from "../../config/config";

const firestore = getFirestore(app);
const auth = getAuth(app);

// ------ snap all income by staff by date & branch ------ //
let incomeStaffSub = [];
export const snapIncomeDetailByDate =
  ({ date, branch }, callback) =>
  (dispatch) => {
    selectIncomeDetailSuccess(dispatch, null);
    const cRef = collection(firestore, REF.INCOME_STAFF_DETAIL);
    const c0 = where("date", "==", date);
    const c1 = where("branch", "==", branch);
    const qRef = query(cRef, c0, c1);
    let unsub = onSnapshot(qRef, (snapshot) => {
      if (snapshot) {
        const data = snapshot.docs.map((doc) => doc.data());
        selectIncomeDetailSuccess(dispatch, data);
        if (callback) {
          callback();
        }
      }
    });

    incomeStaffSub.push(unsub);
  };

export const unSnapIncomeDetail = () => (dispatch) => {
  incomeStaffSub.forEach((subscriber) => {
    subscriber();
  });

  incomeStaffSub.length = 0;
};

// ----- dispatch ------- //
const selectIncomeDetailSuccess = (dispatch, data) => {
  dispatch({
    type: TYPES.SELECT_ALL_INCOME_SUCCESS,
    payload: data,
  });
};

// ----- create IncomeDetail ----- //
export const createIncomeDetail =
  ({ data }, callback) =>
  (dispatch) => {
    const cRef = collection(firestore, REF.INCOME_STAFF_DETAIL);
    if (data) {
      const id = doc(cRef).id;
      const date = data?.date;
      const onDate = moment(date, "DD/MM/YYYY").toDate();
      const dRef = doc(cRef, id);
      let created = {
        ...data,
        id,
        createAt: serverTimestamp(),
        onDate,
      };
      setDoc(dRef, created, { merge: true })
        .then(() => {
          if (callback) {
            callback({
              status: 200,
            });
          }
        })
        .catch((err) => {
          if (callback) {
            callback({
              status: 500,
              data: err?.message || "Please try again!",
            });
          }
        });
    }
  };
// ---- update incomeDetail ----- //

export const updateIncomeDetail =
  ({ data }, callback) =>
  (dispatch) => {
    const cRef = collection(firestore, REF.INCOME_STAFF_DETAIL);
    if (data) {
      const id = data?.id;
      const dRef = doc(cRef, id);
      let update = {
        ...data,
        updateAt: serverTimestamp(),
      };
      setDoc(dRef, update, { merge: true })
        .then(() => {
          if (callback) {
            callback({
              status: 200,
            });
          }
        })
        .catch((err) => {
          if (callback) {
            callback({
              status: 500,
              data: err?.message || "Please try again!",
            });
          }
        });
    }
  };

// ----- delete incomeDetail ----- //

export const deleteIncomeDetail =
  ({ data }, callback) =>
  (dispatch) => {
    const cRef = collection(firestore, REF.INCOME_STAFF_DETAIL);
    if (data) {
      const id = data?.id;
      const dRef = doc(cRef, id);
      deleteDoc(dRef)
        .then(() => {
          if (callback) {
            callback({
              status: 200,
            });
          }
        })
        .catch((err) => {
          if (callback) {
            callback({
              status: 500,
              data: err?.message || "Please try again!",
            });
          }
        });
    }
  };
